import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ContentChange, QuillEditorComponent } from 'ngx-quill';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
})
export class TextEditorComponent implements OnInit {
  @Input() public fc: UntypedFormControl;
  @Input() public label: string | undefined = undefined;
  @Input() public placeholder: string = '';
  @Input() public maxLength: number | undefined = undefined;

  @ViewChild('editor', {
    static: true,
  })
  editor: QuillEditorComponent | undefined;

  ngOnInit(): void {
    this.editor?.onContentChanged.subscribe(({ editor }: ContentChange) => {
      if (this.maxLength && editor.getLength() > this.maxLength) {
        editor.deleteText(this.maxLength, editor.getLength());
      }
    });
  }
}
